// extracted by mini-css-extract-plugin
module.exports = {"inputGroups":"_2l5BZ9HA"};